import React, { Component } from 'react';
import ViewHeader from '../../components/ViewHeader';
import ModuleContainer from '../../components/ModuleContainer';
import { FaPencilAlt, FaRegWindowClose, FaArrowLeft, FaTrashAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { connect } from 'react-redux';
import { Image as NativeImage } from 'react-native';
import { bindActionCreators } from 'redux';
import FormTemplate from '../../components/FormTemplate';
import { Row, Col } from 'react-bootstrap';
import { IMAGE_SIZE, MODE_ADD, MODE_VIEW, MODE_EDIT, ERROR, DATE_FORMAT, NOTIF_ERROR, NOTIF_SUCCESS, SUCCESS, ADTYPE_REDEEM, DEFAULT_STORE_ID, MODE_PENDING,
    EMPTY_STRING, PENDING_ADS, ADS_DETAILS, SECONDARY, APPROVE_BUTTON, SUCCESS_BUTTON, DANGER, PRIMARY, YES, NO, CANCEL, SAVE, BACK, DECLINE, UPDATE, DELETE,
    IS_OBJECT
} from '../../../utils/constants';
import { isNullOrUndefined } from 'util';
import { STORES_ROUTE, VIEW_STORE_ROUTE } from './routes';
import moment from 'moment';
import { REST_SERVICE_URL_ROOT } from '../../../config/settings';
import ConfirmationModal from '../../components/ConfirmationModal';
import { SideNotification, adsImageStyle, isValidImageType } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, MSG_CONFIRM_CHANGES, ADS_IMAGE_REQUIRED, IMAGE_SIZE_MESSAGE, RECOMMENENDED_SIZE, SAVE_CHANGES, DELETE_ADS,
    DELETE_MESSAGE, APPROVE_ADS, APPROVE, DECLINE_PENDING_ADS, DECLINE_ADS, MSG_INVALID_IMAGE_TYPE} from '../../../utils/messages';
import { adsSelectors, adsOperations } from './state';
import { withRouter } from 'react-router-dom';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import adsDummyImg from '../../../includes/img/adsDummy.jpg';
import debounce from 'lodash.debounce';

class ViewAdvertisement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageFile: null,
            imageFileUrl: null,
            storeId: props.storeId,
            adsId: 0,
            mode: MODE_ADD,
            initialAdsDetails: null,
            imageHash: Date.now(),
            imageError: false,
            showSaveModal: false,
            showDeleteModal: false,
            showApproveModal: false,
            showDeclineModal: false,
            adsDetails: [],
            editorState: EditorState.createEmpty(),
            prevEditorState: EditorState.createEmpty(),
            imageErrorSize: false
        }

        //Required to make submission possible on external button
        this.submitForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);
        this.deleteAdvertisement = debounce(this.deleteAdvertisement.bind(this), 500);
    }

    componentDidMount() {
        let storeId = this.props.match.params.id;
        let adsId = this.props.match.params.adsId;

        if (undefined === storeId || isNaN(storeId)) {
            this.props.history.push(STORES_ROUTE)
        } else if (undefined === adsId) {
            this.setState({ mode: MODE_ADD, storeId })
        } else {
            let type = isNullOrUndefined(this.props.location.state) ? MODE_VIEW : this.props.location.state.type;

            this.setState({ storeId, adsId, mode: type }, () => {
                this.props.getAdsById(this.state.adsId)
                    .then((response) => {
                        if (ERROR === response.status) {
                            SideNotification(NOTIF_ERROR, response.message)
                        } else {
                            let contentState = null;
                            let ads = response.data;
                            let blocksFromHtml = htmlToDraft(ads.adsDescription);
                            let { contentBlocks, entityMap } = blocksFromHtml;

                            ads.startDate = moment(ads.startDate).format(DATE_FORMAT);
                            ads.endDate = moment(ads.endDate).format(DATE_FORMAT);
                            contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            response.data.editorState =
                                this.setState({ initialAdsDetails: { AdsModel: ads }, editorState: EditorState.createWithContent(contentState), prevEditorState: EditorState.createWithContent(contentState) })
                        }
                    })
                    .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
            })
        }
    }

    isViewMode = () => {
        return MODE_VIEW === this.state.mode;
    }

    uploadImageContainer = () => {
        return (
            <React.Fragment>
                <Row style={{ padding: 0 }}>
                    <Col md={6} style={{ padding: 0 }}>
                        <img src={adsDummyImg} width={150} alt="phone reference" />
                    </Col>

                    <Col md={6} style={{ padding: 0 }}>
                        <center><label><b className={this.isViewMode() ? EMPTY_STRING : "required-input"}>Advertisement Image</b></label><br /></center><br />
                        <Col className="flex-align">
                            <center>
                                <NativeImage
                                    source={{ uri: (isNullOrUndefined(this.state.imageFile) ? `${REST_SERVICE_URL_ROOT}/ads/image/${this.state.adsId}?${this.state.imageHash}` : this.state.imageFileUrl) }}
                                    style={adsImageStyle}
                                    resizeMode={(MODE_ADD === this.state.mode && isNullOrUndefined(this.state.imageFile)) ? "contain" : "cover"}
                                />
                            </center>
                        </Col>
                        <br />
                        {(MODE_VIEW !== this.state.mode && MODE_PENDING !== this.state.mode) && (
                            <div className="flex-align">
                                <div>
                                    <center>
                                        {this.state.imageError && <><label className="formik-error">{ADS_IMAGE_REQUIRED}</label><br /></>}
                                        {this.state.imageErrorSize && <><label className="formik-error">{IMAGE_SIZE_MESSAGE}</label><br /></>}
                                        <input type='file' id='photo' accept='image/*' onChange={this.handleImageFile} style={{ width: 240 }} /><br /><br />
                                        <b>{RECOMMENENDED_SIZE}</b>
                                    </center>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderRightButtons = () => {
        switch (this.state.mode) {
            case MODE_ADD: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: () => this.returnToList() },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_EDIT: {
                return [
                    { variant: SECONDARY, label: CANCEL, icon: FaRegWindowClose, onClick: this.onCancelClick },
                    { variant: SUCCESS_BUTTON, label: SAVE, icon: FaPencilAlt, onClick: this.onSubmitClick },
                ]
            }
            case MODE_PENDING: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.returnToList() },
                    { variant: SUCCESS_BUTTON, label: APPROVE_BUTTON, icon: FaCheckCircle, onClick: () => this.toggleApprove() },
                    { variant: DANGER, label: DECLINE, icon: FaTimesCircle, onClick: () => this.toggleDecline() },
                ]
            }
            default: {
                return [
                    { variant: SECONDARY, label: BACK, icon: FaArrowLeft, onClick: () => this.returnToList() },
                    { variant: PRIMARY, label: UPDATE, icon: FaPencilAlt, onClick: () => this.updateMode(MODE_EDIT) },
                    { variant: DANGER, label: DELETE, icon: FaTrashAlt, onClick: this.toggleDelete }
                ]
            }
        }
    }

    returnToList = () => {
        this.props.history.push(VIEW_STORE_ROUTE + `/${this.state.storeId}`);
    }

    handleImageFile = (event) => {
        if (isNullOrUndefined(event.target.files[0]) || isValidImageType(event.target.files[0])) {
            if (!isNullOrUndefined(event.target.files[0]) && Number(IMAGE_SIZE) < event.target.files[0].size) {
                this.setState({ imageErrorSize: Number(IMAGE_SIZE) < Number(event.target.files[0].size), imageError: false, imageFile: null })
            }
            else {
                this.setState({ imageFile: event.target.files[0], imageErrorSize: false, imageFileUrl: isNullOrUndefined(event.target.files[0]) ? null : URL.createObjectURL(event.target.files[0]) }, () => { MODE_ADD === this.state.mode && this.setState({ imageError: isNullOrUndefined(this.state.imageFile) }) })
            }
        } else {
            SideNotification(NOTIF_ERROR, MSG_INVALID_IMAGE_TYPE);
        }
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {
        this.form.submitForm();
        if (MODE_ADD === this.state.mode) {
            this.setState({ imageError: isNullOrUndefined(this.state.imageFile) })
        }
    }

    onCancelClick = () => {
        this.form.resetForm(this.state.initialAdsDetails);
        this.updateMode(MODE_VIEW);
        this.setState(prevState => ({ editorState: prevState.prevEditorState }))
    }

    updateMode = (mode) => {
        this.setState({ mode });
    }

    handleSubmit = (values) => {

        let value = values.AdsModel.adsDescription
        let contentState = null;
        let blocksFromHtml = htmlToDraft(value);
        let { contentBlocks, entityMap } = blocksFromHtml;

        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        if (isNullOrUndefined(this.state.imageFile) && MODE_ADD === this.state.mode) {
            this.setState({ imageError: true })
        } else {
            this.setState({ 
                imageError: false, 
                imageErrorSize: false, 
                adsDetails: values,
                editorState: EditorState.createWithContent(contentState),
                prevEditorState: EditorState.createWithContent(contentState),
                
              }, () => this.toggleSave());
        }
    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal }));
    }

    toggleDelete = () => {
        this.setState(prevState => ({ showDeleteModal: !prevState.showDeleteModal }))
    }

    toggleApprove = () => {
        this.setState(prevState => ({ showApproveModal: !prevState.showApproveModal }))
    }

    toggleDecline = () => {
        this.setState(prevState => ({ showDeclineModal: !prevState.showDeclineModal }))
    }

    saveChanges = () => {
        let values = this.state.adsDetails;
        values.AdsModel.storeId = this.state.storeId;
        values.AdsModel.adsPrice = IS_OBJECT === typeof values.AdsModel.adsPrice ? values.AdsModel.adsPrice.floatValue : values.AdsModel.adsPrice
        if (DEFAULT_STORE_ID !== Number(this.state.storeId)) {
            values.AdsModel.adTypeId = ADTYPE_REDEEM;
        }

        if (MODE_EDIT === this.state.mode) {
            this.props.updateAd(values.AdsModel, this.state.imageFile)
                .then(result => {
                    if (SUCCESS === result.status) {
                        this.setState({ mode: MODE_VIEW, showSaveModal: false, initialAdsDetails: { AdsModel: values.AdsModel } })
                        SideNotification(NOTIF_SUCCESS, result.message);
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        } else {
            this.props.insertAd(values.AdsModel, this.state.imageFile, true)
                .then(result => {
                    if (SUCCESS === result.status) {
                        SideNotification(NOTIF_SUCCESS, result.message);
                        this.props.history.push({ pathname: VIEW_STORE_ROUTE + `/${this.state.storeId}`, state: { type: MODE_VIEW } });
                    } else {
                        SideNotification(NOTIF_ERROR, result.message);
                    }
                })
                .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
        }
    }

    updateEditorState = (editorState) => {
        this.setState({ editorState })
    }

    deleteAdvertisement = () => {
        this.props.deleteAd(this.state.adsId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.returnToList()
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    approveAdvertisement = () => {
        this.props.approveAd(this.state.adsId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.returnToList()
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleApprove();
            });
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={MODE_PENDING === this.state.mode ? PENDING_ADS : ADS_DETAILS}
                    rightButtons={this.renderRightButtons()}
                />
                <Row style={{ paddingTop: '30px' }}>
                    <Col md={6} className="flex-align">
                        <div>{this.uploadImageContainer()}</div>
                    </Col>

                    <Col md={6} className="flex-align">
                        <FormTemplate
                            editMode={MODE_ADD !== this.state.mode}
                            readOnly={MODE_VIEW === this.state.mode || MODE_PENDING === this.state.mode}
                            initialValues={this.state.initialAdsDetails}
                            bindSubmitFormik={this.bindSubmitFormik}
                            formInputs={this.props.adsForm}
                            validate={adsSelectors.validateForm}
                            updateFormRef={this.updateFormRef}
                            handleSubmit={this.handleSubmit}
                            editorState={this.state.editorState}
                            updateEditorState={this.updateEditorState}
                            selectInput={this.props.adTypeSelection}
                            storeId={this.state.storeId}
                        />
                    </Col>
                </Row>
                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_ADS}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteAdvertisement, variant: DANGER }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showApproveModal}
                    toggleModal={this.toggleApprove}
                    title={APPROVE_ADS}
                    message={APPROVE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleApprove, variant: SECONDARY },
                        { label: YES, onClick: this.approveAdvertisement, variant: SUCCESS_BUTTON }
                    ]}
                />

                <ConfirmationModal
                    show={this.state.showDeclineModal}
                    toggleModal={this.toggleDecline}
                    title={DECLINE_PENDING_ADS}
                    message={DECLINE_ADS}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDecline, variant: SECONDARY },
                        { label: YES, onClick: this.deleteAdvertisement, variant: DANGER }
                    ]}
                />
            </ModuleContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        adsForm: state.ads.adsForm,
        adTypeSelection: state.ads.adTypeSelection
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        updateAd: adsOperations.updateAd,
        insertAd: adsOperations.insertAd,
        getAdsById: adsOperations.getAdsById,
        deleteAd: adsOperations.deleteAd,
        approveAd: adsOperations.approveAd
    },
    dispatch
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewAdvertisement));